<div class="container-fluid complyon-page supplier-register-page px-3 px-md-4 px-xl-4 py-3">
  <div class="complyon-shell supplier-register-shell mx-auto">
    <section class="mb-3">
      <h1 class="complyon-title supplier-register-title mb-2 text-l">Supplier register</h1>
      <p class="complyon-subtitle supplier-register-subtitle mb-0 text-s">
        Activated suppliers under ongoing monitoring - annual refresh, performance, payment risk, conflict checks. New suppliers originate in OnboardOS.
      </p>
    </section>

    <section class="d-flex align-items-start justify-content-between gap-3 flex-wrap mb-3">
      <div class="d-flex flex-wrap align-items-center gap-2">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          type="button"
          class="btn doa-tab-btn d-inline-flex align-items-center gap-2"
          :class="{ active: active_tab === tab.id }"
          @click="set_tab(tab.id)"
        >
          <span>{{ tab.label }}</span>
          <span v-if="tab.count !== null" class="doa-tab-count">{{ tab.count }}</span>
        </button>
      </div>
      <button type="button" class="btn btn-link doa-reset-btn text-decoration-none d-inline-flex align-items-center gap-2">
        <i class="bi bi-arrow-counterclockwise"></i>
        <span>Reset sample</span>
      </button>
    </section>

    <div v-if="active_tab === 'register'">
      <section class="row row-cols-1 row-cols-md-2 row-cols-xl-5 g-3 mb-3">
        <div v-for="card in summary_cards" :key="card.label">
          <article class="complyon-card supplier-register-card rounded-4 p-3 h-100">
            <div class="supplier-register-stat-label text-xs">{{ card.label }}</div>
            <div class="supplier-register-stat-value" :class="card.accent === 'red' ? 'text-danger' : card.accent === 'amber' ? 'text-warning-emphasis' : card.accent === 'green' ? 'text-success' : 'text-dark'">
              {{ card.value }}
            </div>
            <div class="supplier-register-stat-note text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel supplier-register-panel rounded-4 overflow-hidden">
        <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
          <div>
            <div class="supplier-register-section-title text-s">Supplier register</div>
            <div class="supplier-register-section-subtitle text-xs">Active suppliers under ongoing compliance monitoring.</div>
          </div>
          <button
            type="button"
            class="btn btn-primary-dark supplier-register-action-btn d-inline-flex align-items-center gap-2"
            @click="open_supplier_modal"
          >
            <i class="bi bi-plus-lg"></i>
            <span>Add supplier</span>
          </button>
        </div>

        <div class="table-responsive">
          <table class="table complyon-table supplier-register-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3 text-xs">Supplier</th>
                <th class="text-xs">Category</th>
                <th class="text-xs">Status</th>
                <th class="text-xs">Risk</th>
                <th class="text-xs">Documents</th>
                <th class="text-xs">Payments</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in suppliers"
                :key="row.supplier"
                :class="{ 'supplier-register-highlight': row.highlighted, 'table-row': row.drawer_key }"
                :role="row.drawer_key ? 'button' : null"
                :tabindex="row.drawer_key ? 0 : null"
                @click="open_drawer(row.drawer_key)"
                @keydown.enter="open_drawer(row.drawer_key)"
                @keydown.space.prevent="open_drawer(row.drawer_key)"
              >
                <td class="ps-3">
                  <div class="supplier-register-name">{{ row.supplier }}</div>
                </td>
                <td>{{ row.category }}</td>
                <td>
                  <span class="badge complyon-badge supplier-register-badge text-xs" :class="row.status.class">{{ row.status.label }}</span>
                </td>
                <td>
                  <span class="badge complyon-badge supplier-register-badge text-xs" :class="row.risk.class">{{ row.risk.label }}</span>
                </td>
                <td>
                  <div class="d-flex align-items-center gap-3">
                    <div class="supplier-register-progress flex-grow-1">
                      <div class="progress rounded-pill">
                        <div
                          class="progress-bar rounded-pill"
                          :style="{ width: `${row.documents}%`, backgroundColor: row.risk.label.startsWith('High') ? '#bd2f1f' : row.documents >= 80 ? '#1c8b58' : '#c7651f' }"
                        ></div>
                      </div>
                    </div>
                    <div class="supplier-register-progress-value">{{ row.documents }}%</div>
                  </div>
                </td>
                <td>
                  <span class="badge complyon-badge supplier-register-badge text-xs" :class="row.payments.class">{{ row.payments.label }}</span>
                </td>
                <td class="text-end text-secondary">
                  <i class="bi bi-chevron-right"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'documents'">
      <section class="row row-cols-1 row-cols-md-2 row-cols-xl-4 g-3 mb-3">
        <div v-for="card in documents_cards" :key="card.label">
          <article class="complyon-card supplier-register-card rounded-4 p-3 h-100">
            <div class="supplier-register-stat-label text-xs">{{ card.label }}</div>
            <div class="supplier-register-stat-value" :class="card.accent === 'red' ? 'text-danger' : card.accent === 'amber' ? 'text-warning-emphasis' : card.accent === 'green' ? 'text-success' : 'text-dark'">
              {{ card.value }}
            </div>
            <div class="supplier-register-stat-note text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel supplier-register-panel rounded-4 overflow-hidden">
        <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
          <div>
            <div class="supplier-register-section-title text-s">Document expiry tracking</div>
            <div class="supplier-register-section-subtitle text-xs">CSD, tax, BBBEE, banking, insurance and contract records across every supplier sorted by urgency.</div>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table complyon-table supplier-register-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3 text-xs">Supplier</th>
                <th class="text-xs">Document</th>
                <th class="text-xs">Reference</th>
                <th class="text-xs">Expires</th>
                <th class="text-xs">Status</th>
                <th class="text-xs">Age</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in documents_rows"
                :key="`${row.supplier}-${row.document}-${row.reference}`"
                :class="{ 'supplier-register-highlight': row.highlighted, 'table-row': true }"
                role="button"
                tabindex="0"
                @click="open_document_drawer(row)"
                @keydown.enter="open_document_drawer(row)"
                @keydown.space.prevent="open_document_drawer(row)"
              >
                <td class="ps-3">
                  <div class="d-flex align-items-center gap-2">
                    <i class="bi bi-file-earmark-text text-danger"></i>
                    <div class="supplier-register-name">{{ row.supplier }}</div>
                  </div>
                </td>
                <td>{{ row.document }}</td>
                <td>{{ row.reference }}</td>
                <td>{{ row.expires }}</td>
                <td>
                  <span class="badge complyon-badge supplier-register-badge text-xs" :class="row.status.class">{{ row.status.label }}</span>
                </td>
                <td class="text-secondary text-nowrap">{{ row.age }}</td>
                <td class="text-end text-secondary">
                  <i class="bi bi-chevron-right"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'renewals'">
      <section class="complyon-panel supplier-register-panel rounded-4 overflow-hidden mb-3" style="background:#eaf7f3;border-color:#bfe8e5;">
        <div class="d-flex align-items-center justify-content-between gap-3 p-3">
          <div class="d-flex align-items-center gap-3">
            <span class="d-inline-flex align-items-center justify-content-center rounded-circle bg-success text-white" style="width:2rem;height:2rem;">
              <i class="bi bi-arrow-repeat"></i>
            </span>
            <div>
              <div class="supplier-register-section-title text-s">Supplier renewal workflow</div>
              <div class="supplier-register-section-subtitle text-xs">Annual refresh: notice - documents - review - renewed. Trigger OnboardOS revalidation from any row.</div>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-outline-secondary d-inline-flex align-items-center gap-2"
            @click="open_default_revalidation_modal"
          >
            <i class="bi bi-box-arrow-up-right"></i>
            <span>Revalidate</span>
          </button>
        </div>
      </section>

      <section class="complyon-panel supplier-register-panel rounded-4 overflow-hidden">
        <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
          <div>
            <div class="supplier-register-section-title text-s">Renewal schedule</div>
            <div class="supplier-register-section-subtitle text-xs">Suppliers, their renewal due date and the workflow stage they are in.</div>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table complyon-table supplier-register-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3 text-xs">Supplier</th>
                <th class="text-xs">Renewal due</th>
                <th class="text-xs">Workflow</th>
                <th class="text-xs">Action</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in renewals_rows"
                :key="row.supplier"
                class="table-row"
                role="button"
                tabindex="0"
                @click="open_renewal_drawer(row)"
                @keydown.enter="open_renewal_drawer(row)"
                @keydown.space.prevent="open_renewal_drawer(row)"
              >
                <td class="ps-3">
                  <div class="supplier-register-name">{{ row.supplier }}</div>
                </td>
                <td>
                  <span class="badge complyon-badge supplier-register-badge text-xs" :class="row.renewal_due === 'Overdue' ? 'bg-danger-subtle text-danger-emphasis' : 'bg-info-subtle text-info-emphasis'">{{ row.renewal_due }}</span>
                </td>
                <td>
                  <div class="d-flex flex-wrap align-items-center gap-2">
                    <span
                      v-for="(step, index) in row.workflow"
                      :key="`${row.supplier}-${step.label}`"
                      class="badge rounded-pill text-nowrap"
                      :class="step.state === 'done' ? 'bg-success-subtle text-success-emphasis' : step.state === 'active' ? 'bg-success text-white' : 'bg-light text-secondary'"
                    >
                      {{ index + 1 }} {{ step.label }}
                    </span>
                  </div>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-outline-secondary btn-sm d-inline-flex align-items-center gap-2"
                    @click.stop="open_revalidation_modal(row)"
                    @keydown.enter.stop="open_revalidation_modal(row)"
                    @keydown.space.prevent.stop="open_revalidation_modal(row)"
                  >
                    <i class="bi bi-box-arrow-up-right"></i>
                    <span>Revalidate</span>
                  </button>
                </td>
                <td class="text-end text-secondary">
                  <i class="bi bi-chevron-right"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'incidents'">
      <section class="row row-cols-1 row-cols-md-2 row-cols-xl-4 g-3 mb-3">
        <div v-for="card in incidents_cards" :key="card.label">
          <article class="complyon-card supplier-register-card rounded-4 p-3 h-100">
            <div class="supplier-register-stat-label text-xs">{{ card.label }}</div>
            <div class="supplier-register-stat-value" :class="card.accent === 'red' ? 'text-danger' : card.accent === 'amber' ? 'text-warning-emphasis' : card.accent === 'green' ? 'text-success' : 'text-dark'">
              {{ card.value }}
            </div>
            <div class="supplier-register-stat-note text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel supplier-register-panel rounded-4 overflow-hidden">
        <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
          <div>
            <div class="supplier-register-section-title text-s">Supplier incidents</div>
            <div class="supplier-register-section-subtitle text-xs">Compliance breaches, delivery, quality, data and conduct issues. Open a supplier to log or resolve.</div>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table complyon-table supplier-register-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3 text-xs">Supplier</th>
                <th class="text-xs">Incident</th>
                <th class="text-xs">Type</th>
                <th class="text-xs">Severity</th>
                <th class="text-xs">Date</th>
                <th class="text-xs">Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in incidents_rows"
                :key="`${row.supplier}-${row.incident}`"
                class="table-row"
                role="button"
                tabindex="0"
                @click="open_incident_drawer(row)"
                @keydown.enter="open_incident_drawer(row)"
                @keydown.space.prevent="open_incident_drawer(row)"
              >
                <td class="ps-3">
                  <div class="supplier-register-name">{{ row.supplier }}</div>
                </td>
                <td>{{ row.incident }}</td>
                <td>{{ row.type }}</td>
                <td>
                  <span class="badge complyon-badge supplier-register-badge text-xs" :class="row.severity.class">{{ row.severity.label }}</span>
                </td>
                <td>{{ row.date }}</td>
                <td>
                  <span class="badge complyon-badge supplier-register-badge text-xs" :class="row.status.class">{{ row.status.label }}</span>
                </td>
                <td class="text-end text-secondary">
                  <i class="bi bi-chevron-right"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div v-else>
      <section class="complyon-panel supplier-register-panel rounded-4 overflow-hidden mb-3" style="background:#eaf7f3;border-color:#bfe8e5;">
        <div class="d-flex align-items-center justify-content-between gap-3 p-3">
          <div class="d-flex align-items-center gap-3">
            <span class="d-inline-flex align-items-center justify-content-center rounded-circle bg-success text-white" style="width:2rem;height:2rem;">
              <i class="bi bi-arrow-repeat"></i>
            </span>
            <div>
              <div class="supplier-register-section-title text-s">Re-onboarding handoff to OnboardOS</div>
              <div class="supplier-register-section-subtitle text-xs">When monitoring detects a lapse, Complyon sends the supplier back to OnboardOS for full re-verification, then resumes monitoring on return.</div>
            </div>
          </div>
          <button type="button" class="btn btn-outline-secondary d-inline-flex align-items-center gap-2">
            <i class="bi bi-box-arrow-up-right"></i>
            <span>Open OnboardOS</span>
          </button>
        </div>
      </section>

      <section class="complyon-panel supplier-register-panel rounded-4 overflow-hidden mb-3">
        <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
          <div>
            <div class="supplier-register-section-title text-s">Sent for revalidation</div>
            <div class="supplier-register-section-subtitle text-xs">Suppliers Complyon has pushed back to OnboardOS. These appear as re-onboarding cases there.</div>
          </div>
          <span class="badge complyon-badge supplier-register-badge text-xs bg-warning-subtle text-warning-emphasis">{{ revalidation_empty.queued }} queued</span>
        </div>
        <div class="table-responsive">
          <table class="table complyon-table supplier-register-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3 text-xs">Supplier</th>
                <th class="text-xs">Reason</th>
                <th class="text-xs">Requested</th>
                <th class="text-xs">Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="5" class="text-center py-4 text-secondary">
                  Nothing in revalidation. Use "Revalidate in OnboardOS" on a supplier to trigger re-onboarding.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="complyon-panel supplier-register-panel rounded-4 overflow-hidden">
        <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
          <div>
            <div class="supplier-register-section-title text-s">Flagged in register</div>
            <div class="supplier-register-section-subtitle text-xs">Marked as in-revalidation - monitoring continues read-only until OnboardOS returns a clean activation.</div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table complyon-table supplier-register-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3 text-xs">Supplier</th>
                <th class="text-xs">Risk</th>
                <th class="text-xs">Payments</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in revalidation_flagged"
                :key="row.supplier"
                class="table-row"
                role="button"
                tabindex="0"
                @click="open_flagged_drawer(row)"
                @keydown.enter="open_flagged_drawer(row)"
                @keydown.space.prevent="open_flagged_drawer(row)"
              >
                <td class="ps-3">
                  <div class="supplier-register-name">{{ row.supplier }}</div>
                </td>
                <td>
                  <span class="badge complyon-badge supplier-register-badge text-xs" :class="row.risk.class">{{ row.risk.label }}</span>
                </td>
                <td>
                  <span class="badge complyon-badge supplier-register-badge text-xs" :class="row.payments.class">{{ row.payments.label }}</span>
                </td>
                <td class="text-end text-secondary">
                  <i class="bi bi-chevron-right"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  </div>

  <div
    v-if="(active_tab === 'register' || active_tab === 'documents' || active_tab === 'renewals' || active_tab === 'incidents' || active_tab === 'revalidation') && (active_drawer || supplier_modal_open || revalidation_modal_open)"
    class="command-centre-drawer-backdrop"
    @click="supplier_modal_open ? close_supplier_modal() : revalidation_modal_open ? close_revalidation_modal() : close_drawer()"
  ></div>

  <div
    v-if="active_tab === 'register' && supplier_modal_open"
    class="supplier-register-modal-wrap"
    role="dialog"
    aria-modal="true"
    aria-label="Add supplier"
  >
    <div class="supplier-register-modal card border-0">
      <div class="supplier-register-modal-header d-flex align-items-start justify-content-between gap-3">
        <div>
          <h2 class="supplier-register-modal-title mb-1">Add supplier</h2>
          <div class="supplier-register-modal-subtitle">
            Register an active supplier for monitoring. Intake and due diligence happen in OnboardOS.
          </div>
        </div>
        <button
          type="button"
          class="btn btn-link text-decoration-none text-secondary p-0"
          @click="close_supplier_modal"
          aria-label="Close add supplier modal"
        >
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="supplier-register-modal-body">
        <div class="mb-3">
          <label class="form-label supplier-register-modal-label">Supplier name</label>
          <input
            v-model="supplier_form.name"
            type="text"
            class="form-control supplier-register-modal-input"
            placeholder="e.g. Horizon Logistics"
          />
        </div>

        <div class="row g-3">
          <div class="col-12 col-md-6">
            <label class="form-label supplier-register-modal-label">Category</label>
            <select v-model="supplier_form.category" class="form-select supplier-register-modal-input">
              <option v-for="option in supplier_category_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label supplier-register-modal-label">Status</label>
            <select v-model="supplier_form.status" class="form-select supplier-register-modal-input">
              <option v-for="option in supplier_status_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label supplier-register-modal-label">Risk score (0-100)</label>
            <input
              v-model="supplier_form.risk_score"
              type="number"
              min="0"
              max="100"
              class="form-control supplier-register-modal-input"
            />
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label supplier-register-modal-label">Owner</label>
            <input
              v-model="supplier_form.owner"
              type="text"
              class="form-control supplier-register-modal-input"
              placeholder="e.g. Procurement"
            />
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label supplier-register-modal-label">Annual spend</label>
            <input
              v-model="supplier_form.annual_spend"
              type="text"
              class="form-control supplier-register-modal-input"
              placeholder="e.g. R 1.2m / yr"
            />
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label supplier-register-modal-label">Supplier since</label>
            <input
              v-model="supplier_form.supplier_since"
              type="text"
              class="form-control supplier-register-modal-input"
              placeholder="e.g. Mar 2024"
            />
          </div>
        </div>
      </div>

      <div class="supplier-register-modal-footer d-flex align-items-center justify-content-end gap-2">
        <button type="button" class="btn btn-link text-decoration-none text-secondary" @click="close_supplier_modal">Cancel</button>
        <button
          type="button"
          class="btn config-navbar-primary-action d-inline-flex align-items-center gap-2"
          @click="save_supplier_modal"
        >
          <i class="bi bi-plus-lg"></i>
          <span>Add supplier</span>
        </button>
      </div>
    </div>
  </div>

  <div
    v-if="active_tab === 'renewals' && revalidation_modal_open && active_revalidation_copy"
    class="supplier-register-modal-wrap"
    role="dialog"
    aria-modal="true"
    aria-label="Send back to OnboardOS for revalidation"
  >
    <div class="supplier-register-modal supplier-register-revalidation-modal card border-0">
      <div class="supplier-register-modal-header d-flex align-items-start justify-content-between gap-3">
        <div>
          <h2 class="supplier-register-modal-title mb-1">{{ active_revalidation_copy.title }}</h2>
          <div class="supplier-register-modal-subtitle">
            {{ active_revalidation_copy.subtitle }}
          </div>
        </div>
        <button
          type="button"
          class="btn btn-link text-decoration-none text-secondary p-0"
          @click="close_revalidation_modal"
          aria-label="Close revalidation modal"
        >
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="supplier-register-modal-body">
        <div class="supplier-register-revalidation-flow">
          <article class="supplier-register-revalidation-step">
            <i class="bi bi-shield-check"></i>
            <div class="supplier-register-revalidation-step-title">Complyon</div>
            <div class="supplier-register-revalidation-step-note">flags & triggers</div>
          </article>
          <span class="supplier-register-revalidation-arrow">
            <i class="bi bi-arrow-right"></i>
          </span>
          <article class="supplier-register-revalidation-step is-warm">
            <i class="bi bi-arrow-repeat"></i>
            <div class="supplier-register-revalidation-step-title">OnboardOS</div>
            <div class="supplier-register-revalidation-step-note">re-verifies</div>
          </article>
          <span class="supplier-register-revalidation-arrow">
            <i class="bi bi-arrow-right"></i>
          </span>
          <article class="supplier-register-revalidation-step">
            <i class="bi bi-box-arrow-in-down-right"></i>
            <div class="supplier-register-revalidation-step-title">Complyon</div>
            <div class="supplier-register-revalidation-step-note">resumes monitoring</div>
          </article>
        </div>

        <div class="mt-3">
          <label class="form-label supplier-register-modal-label">Reason for revalidation</label>
          <select v-model="active_revalidation_reason" class="form-select supplier-register-modal-input">
            <option v-for="option in revalidation_reason_options" :key="option" :value="option">{{ option }}</option>
          </select>
        </div>

        <div class="supplier-register-revalidation-note mt-3">
          <i class="bi bi-info-circle"></i>
          <span>
            While in revalidation the supplier stays visible here in read-only monitoring. Payments can remain blocked until OnboardOS returns a clean activation.
          </span>
        </div>
      </div>

      <div class="supplier-register-modal-footer d-flex align-items-center justify-content-end gap-2">
        <button type="button" class="btn btn-link text-decoration-none text-secondary" @click="close_revalidation_modal">Cancel</button>
        <button
          type="button"
          class="btn config-navbar-primary-action d-inline-flex align-items-center gap-2"
          @click="submit_revalidation_modal"
        >
          <i class="bi bi-box-arrow-up-right"></i>
          <span>Send to OnboardOS</span>
        </button>
      </div>
    </div>
  </div>

  <aside
    v-if="(active_tab === 'register' || active_tab === 'documents' || active_tab === 'renewals' || active_tab === 'incidents' || active_tab === 'revalidation') && active_drawer"
    class="command-centre-drawer supplier-register-drawer"
    aria-label="Supplier drawer"
  >
    <div class="command-centre-drawer-header border-bottom">
      <div class="d-flex align-items-start justify-content-between gap-3">
        <div class="min-w-0">
          <div class="command-centre-drawer-kicker text-uppercase">{{ active_drawer.section }}</div>
          <h2 class="command-centre-drawer-title mb-1 text-truncate">{{ active_drawer.title }}</h2>
          <div class="command-centre-drawer-subtitle text-truncate">{{ active_drawer.subtitle }}</div>
        </div>
        <div class="d-flex align-items-center gap-2 flex-shrink-0">
          <span class="badge rounded-pill" :class="active_drawer.status_class">{{ active_drawer.status }}</span>
          <button
            type="button"
            class="btn btn-link text-decoration-none p-0 command-centre-drawer-close"
            @click="close_drawer"
            aria-label="Close drawer"
          >
            <i class="bi bi-x-lg fs-5"></i>
          </button>
        </div>
      </div>
    </div>

    <div ref="drawerBody" class="command-centre-drawer-body">
      <section class="supplier-register-monitoring-card mb-3">
        <div class="d-flex align-items-start gap-2">
          <span class="supplier-register-monitoring-icon">
            <i class="bi bi-activity"></i>
          </span>
          <div class="supplier-register-monitoring-copy">{{ active_drawer.monitoring_note }}</div>
        </div>
      </section>

      <section class="supplier-register-drawer-grid mb-4">
        <article
          v-for="stat in active_drawer.stats"
          :key="stat.label"
          class="supplier-register-drawer-stat"
          :class="`is-${stat.tone}`"
        >
          <div class="supplier-register-drawer-stat-label">{{ stat.label }}</div>
          <div class="supplier-register-drawer-stat-value">{{ stat.value }}</div>
          <div v-if="typeof stat.progress === 'number'" class="supplier-register-drawer-mini-progress">
            <div class="supplier-register-drawer-mini-track">
              <div class="supplier-register-drawer-mini-fill" :style="{ width: `${stat.progress}%` }"></div>
            </div>
            <span>{{ stat.progress }}%</span>
          </div>
          <div v-else class="supplier-register-drawer-stat-note">{{ stat.note }}</div>
        </article>
      </section>

      <section class="mb-4">
        <div class="supplier-register-drawer-section-head">
          <span>Compliance records & expiry</span>
        </div>
        <div class="supplier-register-drawer-records">
          <article
            v-for="record in active_drawer.records"
            :key="`${record.title}-${record.subtitle}`"
            class="supplier-register-drawer-record"
          >
            <div class="d-flex align-items-start justify-content-between gap-2">
              <div class="d-flex align-items-start gap-2 min-w-0">
                <span class="supplier-register-drawer-record-icon">
                  <i class="bi bi-file-earmark-medical"></i>
                </span>
                <div class="min-w-0">
                  <div class="supplier-register-drawer-record-title">{{ record.title }}</div>
                  <div class="supplier-register-drawer-record-subtitle">{{ record.subtitle || '-' }}</div>
                </div>
              </div>
              <span v-if="record.status" class="badge rounded-pill text-nowrap" :class="record.status_class">{{ record.status }}</span>
            </div>
            <div v-if="record.age" class="supplier-register-drawer-record-age">{{ record.age }}</div>
          </article>
        </div>
      </section>

      <section v-if="active_drawer.links && active_drawer.links.length" class="mb-4">
        <div class="supplier-register-drawer-section-head d-flex align-items-center justify-content-between gap-2">
          <span>Conflict-of-interest links</span>
        </div>
        <div class="d-flex flex-column gap-2">
          <article
            v-for="item in active_drawer.links"
            :key="item.title"
            class="supplier-register-drawer-inline-card"
          >
            <div class="d-flex align-items-start gap-2">
              <span class="supplier-register-inline-icon">
                <i class="bi" :class="item.icon || 'bi-link-45deg'"></i>
              </span>
              <div>
                <div class="supplier-register-drawer-record-title">{{ item.title }}</div>
                <div class="supplier-register-drawer-record-subtitle">{{ item.subtitle }}</div>
              </div>
            </div>
          </article>
        </div>
      </section>

      <section class="mb-4">
        <div class="supplier-register-drawer-section-head d-flex align-items-center justify-content-between gap-2">
          <span>Incidents & performance</span>
          <button type="button" class="btn btn-link text-decoration-none supplier-register-inline-link">+ Log</button>
        </div>
        <div v-if="active_drawer.incidents && active_drawer.incidents.length" class="d-flex flex-column gap-2">
          <article
            v-for="item in active_drawer.incidents"
            :key="item.title"
            class="supplier-register-drawer-inline-card"
          >
            <div class="d-flex align-items-start justify-content-between gap-2">
              <div class="d-flex align-items-start gap-2">
                <span class="supplier-register-inline-icon" :class="item.status ? 'is-alert' : ''">
                  <i class="bi" :class="item.icon || 'bi-exclamation-triangle'"></i>
                </span>
                <div>
                  <div class="supplier-register-drawer-record-title">{{ item.title }}</div>
                  <div v-if="item.subtitle" class="supplier-register-drawer-record-subtitle">{{ item.subtitle }}</div>
                </div>
              </div>
              <span v-if="item.status" class="badge rounded-pill text-nowrap" :class="item.status_class">{{ item.status }}</span>
            </div>
          </article>
        </div>
        <div v-else class="supplier-register-empty-note">No incidents logged.</div>
      </section>

      <section class="mb-4">
        <div class="supplier-register-drawer-section-head">
          <span>Renewal workflow - {{ active_drawer.workflow ? active_drawer.workflow.due : '' }}</span>
        </div>
        <div class="supplier-register-drawer-workflow">
          <div
            v-for="(step, index) in active_drawer.workflow ? active_drawer.workflow.steps : []"
            :key="`${step.label}-${index}`"
            class="supplier-register-drawer-workflow-step"
          >
            <span class="supplier-register-drawer-workflow-dot" :class="`is-${step.state}`">{{ index + 1 }}</span>
            <span class="supplier-register-drawer-workflow-label">{{ step.label }}</span>
          </div>
        </div>
      </section>

      <section v-if="active_drawer.evidence && active_drawer.evidence.length" class="mb-2">
        <div class="supplier-register-drawer-section-head">
          <span>Audit evidence</span>
        </div>
        <div class="d-flex flex-column gap-2">
          <article
            v-for="item in active_drawer.evidence"
            :key="item.title"
            class="supplier-register-drawer-inline-card"
          >
            <div class="d-flex align-items-start gap-2">
              <span class="supplier-register-inline-icon">
                <i class="bi bi-file-earmark-text"></i>
              </span>
              <div>
                <div class="supplier-register-drawer-record-title">{{ item.title }}</div>
                <div class="supplier-register-drawer-record-subtitle">{{ item.subtitle }}</div>
              </div>
            </div>
          </article>
        </div>
      </section>
    </div>

    <div v-if="active_drawer.footer_actions && active_drawer.footer_actions.length" class="command-centre-drawer-footer border-top">
      <div class="d-flex flex-wrap gap-2 align-items-center">
        <div
          v-if="active_drawer_footer_primary_actions.length"
          class="command-centre-drawer-footer-left d-flex align-items-center gap-2"
        >
          <button
            v-for="action in active_drawer_footer_primary_actions"
            :key="action.label"
            type="button"
            class="btn d-inline-flex align-items-center gap-2"
            @click="handle_drawer_action(action)"
            :class="action.variant === 'primary'
              ? 'config-navbar-primary-action'
              : action.variant === 'secondary'
                ? 'config-navbar-secondary-action'
                : action.variant === 'outline-danger'
                  ? 'btn-outline-danger'
                  : action.variant === 'outline-warning'
                    ? 'btn-outline-warning'
                    : action.variant === 'outline-secondary'
                      ? 'btn-outline-secondary'
                      : 'btn-link text-decoration-none text-secondary px-0'"
          >
            <i class="bi" :class="action.icon"></i>
            <span>{{ action.label }}</span>
          </button>
        </div>

        <div class="command-centre-drawer-footer-actions ms-auto d-flex flex-wrap gap-2 align-items-center">
          <button
            v-for="action in active_drawer_footer_actions"
            :key="action.label"
            type="button"
            class="btn d-inline-flex align-items-center gap-2"
            @click="handle_drawer_action(action)"
            :class="action.variant === 'primary'
              ? 'config-navbar-primary-action'
              : action.variant === 'secondary'
                ? 'config-navbar-secondary-action'
                : action.variant === 'outline-danger'
                  ? 'btn-outline-danger'
                  : action.variant === 'outline-warning'
                    ? 'btn-outline-warning'
                    : action.variant === 'outline-secondary'
                      ? 'btn-outline-secondary'
                      : 'btn-link text-decoration-none text-secondary px-0'"
          >
            <i class="bi" :class="action.icon"></i>
            <span>{{ action.label }}</span>
          </button>
        </div>
      </div>
    </div>
  </aside>
</div>
